import { useState } from "react";
import { useMap } from "react-leaflet";
import { LocateFixed, Search, Loader2, X } from "lucide-react";
import { toast } from "sonner";

export function FlyTo({ target }) {
  const map = useMap();
  if (target) map.flyTo([target.lat, target.lng], target.zoom || 13, { duration: 0.8 });
  return null;
}

export default function AddressSearch({ onLocate, onClear, active }) {
  const [q, setQ] = useState("");
  const [busy, setBusy] = useState(false);

  const search = async () => {
    if (!q.trim()) return;
    setBusy(true);
    try {
      const r = await fetch(`https://nominatim.openstreetmap.org/search?format=json&limit=1&countrycodes=fr&q=${encodeURIComponent(q)}`, { headers: { "Accept-Language": "fr" } });
      const data = await r.json();
      if (!data.length) return toast.error("Adresse introuvable");
      onLocate({ lat: Number(data[0].lat), lng: Number(data[0].lon), label: data[0].display_name.split(",").slice(0, 2).join(",") });
    } catch { toast.error("Recherche indisponible"); }
    finally { setBusy(false); }
  };

  const me = () => {
    if (!navigator.geolocation) return toast.error("Géolocalisation indisponible");
    setBusy(true);
    navigator.geolocation.getCurrentPosition(
      (p) => { onLocate({ lat: p.coords.latitude, lng: p.coords.longitude, label: "Ma position" }); setBusy(false); },
      () => { toast.error("Position refusée"); setBusy(false); }
    );
  };

  return (
    <div className="flex items-center gap-2 w-full sm:w-auto" data-testid="address-search">
      <div className="flex items-center flex-1 sm:w-72 bg-white border border-slate-200 rounded-full pl-3 pr-1 py-1">
        <Search className="w-4 h-4 text-slate-400" />
        <input data-testid="address-input" className="flex-1 px-2 py-1 text-sm outline-none bg-transparent" placeholder="Adresse, ville, quartier…" value={q}
          onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && search()} />
        <button data-testid="address-submit" onClick={search} disabled={busy} className="text-xs font-semibold px-3 py-1 rounded-full bg-slate-900 text-white disabled:opacity-50">
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : "OK"}
        </button>
      </div>
      <button data-testid="around-me-btn" onClick={me} className={`sc-btn text-sm ${active ? "sc-btn-emerald" : "sc-btn-outline"}`}><LocateFixed className="w-4 h-4" /> Autour de moi</button>
      {active && <button data-testid="clear-location" onClick={onClear} className="p-2 rounded-full border border-slate-200 bg-white hover:bg-slate-100" aria-label="Effacer"><X className="w-4 h-4" /></button>}
    </div>
  );
}

export const distanceKm = (a, b) => {
  const R = 6371, dLat = ((b.lat - a.lat) * Math.PI) / 180, dLng = ((b.lng - a.lng) * Math.PI) / 180;
  const h = Math.sin(dLat / 2) ** 2 + Math.cos((a.lat * Math.PI) / 180) * Math.cos((b.lat * Math.PI) / 180) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
};
